<template>
    <div class="login-screen">
        <slick ref="loginSlider" @afterChange="setCurrentSlide" class="login-slider" v-if="artwork" :options="slickOptions">
            <div v-for="(art, $index) in artwork" class="art-wrapper">
                <div :class="{'animated':$index === currentSlide }" class="artwork" :style="{backgroundImage:'url(' + art.url + ')'}">
                </div>
                <div class="credit">{{art.credit}}</div>
            </div>
        </slick>
        <section class="login">
            <img src="../assets/img/logo.png" alt="ThinkTank Online">
            <h1>Portal</h1>
            <form id="login">
                <div class="form-group">
                    <input v-if="showRegistrationInput" class="form-control" type="text" name="registration_code" v-model="registrationCode" placeholder="Registration Code">
                    <input v-if="!showRegistrationInput" class="form-control" id="login-email" type="email" v-model="credentials.username" placeholder="Email Address">
                    <input v-if="!showRegistrationInput" class="form-control" id="login-password" type="password" v-model="credentials.password" placeholder="Password">
                    <a v-if="!showRegistrationInput" class="forgot-password" href="#" @click.prevent="forgotPassword()">Forgot Password?</a>
                    <input v-if="showRegistrationInput" class="form-control" type="email" v-model="credentials.username" placeholder="Email Address" required>
                    <input v-if="showRegistrationInput" class="form-control" type="password" v-model="credentials.password" placeholder="Set Password" required>
                </div>
                <button @click.prevent="register()" v-if="showRegistrationInput" class="btn btn-default" type="submit">Activate Account</button>
                <button id="login-submit" @click.prevent="login()" v-if="!showRegistrationInput" class="btn btn-default" type="submit">Enter</button>
            </form>
        </section>
    </div>
</template>
<script>
import auth from '../services/auth';
import chat from '../services/chat';
import users from '../services/users';
import terms from '../services/terms';
import axios from 'axios';
import * as Sentry from "@sentry/browser";

import router from '../router';
import toastr from 'toastr';
import _ from 'underscore';
import Slick from 'vue-slick';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import UAParser from 'ua-parser-js';

import '../../node_modules/slick-carousel/slick/slick.css';

export default {
    data() {
        return {
            terms: null,
            credentials: {
                username: '',
                password: ''
            },
            showRegistrationInput: false,
            registrationCode: '',
            artwork: null,
            slickOptions: {
                slidesToShow: 1,
                arrows: false,
                autoplay: true,
                speed: 1000,
                autoplaySpeed: 10000,
                fade: true,
                infinite: true,
                pauseOnFocus: false,
                pauseOnHover: false,
            },
            currentSlide: 0

        }
    },
    components: { Slick },
    mounted() {

        this.getArtwork();
        this.getTerms();

        if (this.$route.name === 'activate') this.showRegistrationInput = true;

       

    },

    methods: {
        getTerms() {
            terms.get(this).then((response) => {
                this.terms = response.data.terms;
            });
        },
        setCurrentSlide(e, slick, current, next) {
            this.currentSlide = current;
        },
        getArtwork() {
            var self = this;
            axios.get('https://ttto-login-artwork.s3-us-west-2.amazonaws.com/').then(function(response) {
                var parseString = require('xml2js').parseString;
                var xml = response.data;
                parseString(xml, function(err, result) {
                    let artwork = result.ListBucketResult.Contents.map(function(c) {
                        return c.Key[0]
                    });
                    artwork = _.shuffle(artwork);
                    self.artwork = artwork.map(function(a) {

                        let fragments = a.replace('.jpg', '').split('Project-');
                        let name = fragments[1].replace(/-/g, ' ');
                        let project = fragments[0].replace(/-/g, ' ');
                        return {
                            url: 'https://ttto-login-artwork.s3-us-west-2.amazonaws.com/' + a,
                            credit: project + ' Project by ' + name
                        }
                    });

                });

            }).catch((e)=>{
                self.artwork = [{
                    url:'https://ttto-utility-bucket.s3.us-west-2.amazonaws.com/alonso-bocanegra-1.jpg',
                    credit: 'Alonso Bocanegra'
                }]
            })


        },
        forgotPassword() {
            if (!this.credentials.username) {
                toastr.error('Please enter your email address');
                return;
            }

            this.credentials.username = this.credentials.username.toLowerCase();

            auth.forgotPassword(this, this.credentials.username).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Please check your email for a password reset link.');
                } else {
                    toastr.error(response.data.message);
                }
            })
        },
        register() {

            function validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            }

            function scorePassword(pass) {
                var validated = true;
                if (pass.length < 8)
                    validated = false;
                if (!/\d/.test(pass))
                    validated = false;
                if (!/[a-z]/.test(pass))
                    validated = false;
                if (!/[A-Z]/.test(pass))
                    validated = false;

                return validated;
            }

            function validRegistrationCode(code) {
                var reg = new RegExp('^[0-9]+$');
                return reg.test(code);
            }
            var self = this;
            var credentials = {
                username: this.credentials.username.toLowerCase(),
                password: this.credentials.password,
                registrationCode: this.registrationCode
            }

            if (!credentials.username || !credentials.password || !credentials.registrationCode) {
                toastr.error("Please enter your registration code, and set your username and password");
                return;
            }
            var validEmail = validateEmail(credentials.username);

            if (validEmail !== true) {
                toastr.error("Please check your email address");
                return;
            }

            var validPassword = scorePassword(credentials.password);
            if (validPassword === false) {
                toastr.error("Please use a strong password, at least 8 characters, with a mixture of uppper- and lower-case letters and numbers, and no special characters");
                return false;
            }

            var validCode = validRegistrationCode(credentials.registrationCode);
            if (validCode === false) {
                toastr.error("Please check your registration code. It should contain only numbers.");
                return false;
            }


            auth.register(this, credentials).then(function(response) {
                if (response.data.success === true) {
                    toastr.success(response.data.message);
                    self.showRegistrationInput = false;
                    self.registrationCode = '';
                } else {
                    toastr.error(response.data.message);
                }
            });
        },
        rocketLogin(credentials) {
            function login() {
                return chat.rocketLogin(null, credentials).then(function(res) {
                    localStorage.rocket_token = res.data.data.authToken;
                    localStorage.rocket_id = res.data.data.userId;

                    users.getMe().then(function(response) {
                        let avatar = response.data.person.avatar;
                        if (avatar) {
                            chat.setRocketAvatar(null, avatar);
                        }
                    });
                });
            }
            login().catch(err => {
                chat.registerRocketChat(null, credentials).then(() => {
                    return login();
                }).catch(err => {
                    console.log('Error while logging in to rocket chat:', err);
                    toastr.error('Failed to log in to chat.');
                });
            });
        },

        login() {

            var self = this;

            this.credentials.username = this.credentials.username.toLowerCase();

            auth.login(this, this.credentials).then(async function(error, response) {
                
                
                if (error === 'Unregistered') {
                    toastr.error('','This account is not yet activated. Please visit <a href="https://portal.tttc.ca/#/activate" target="_blank">https://portal.tttc.ca/#/activate</a> to activate your account for the term. You will need your student number (registration code), which you can find in the email you received entitled "Welcome to Think Tank Online"');
                    return false;
                }
                if (error === 'Disabled') {
                    toastr.error('','This account has been disabled. Please contact staff if you think this is an error.');
                    return false;
                }
                if (error) {
                    toastr.error('Incorrect username or password');
                } else {
                        
                    self.$ga.set('userId', localStorage.user_id);  
                    self.$gtag.set('user_id', localStorage.user_id);

                    if (window.location.hostname === 'portal.tttc.ca') {
                        Sentry.setUser({ username: localStorage.user_name });
                    }

                    self.$bus.$emit('login');
                    const fp = await FingerprintJS.load();
                    const result = await fp.get();
                    const browserId = result.visitorId;
                    self.$store.dispatch('populate', {
                        type: 'browserId',
                        data: browserId
                    });
                    
                    const userAgent = UAParser(navigator.userAgent);

                    self.$socket.emit('authorized', localStorage.user_id, localStorage.user_name, browserId, userAgent, true);

                    if (window.location.hostname == 'portal.tttc.ca') {
                        if (!localStorage.roles.includes('LiteStudent')) {
                            self.rocketLogin(self.credentials);
                        }
                    }

                    if (Notification.permission === 'default') {
                        Notification.requestPermission();
                    }

                    function getQueryVariable(variable) {
                        var query = window.location.search.substring(1);
                        var vars = query.split('&');
                        for (var i = 0; i < vars.length; i++) {
                            var pair = vars[i].split('=');
                            if (decodeURIComponent(pair[0]) == variable) {
                                return decodeURIComponent(pair[1]);
                            }
                        }
                        console.log('Query variable %s not found', variable);
                    }

                    if (localStorage.roles.includes('Recruiter')) {
                        self.$router.push('/galleries');
                    } else if (localStorage.roles.indexOf('Admin') > -1) {
                        self.$router.push('/forum');
                    } 
                    else if (localStorage.roles.indexOf('CourseAdmin') > -1 || localStorage.roles.indexOf('LessonAuditor') > -1) {
                        self.$router.push('/dashboard');
                    } else if (localStorage.roles.indexOf('CampusDirector') > -1) {
                        self.$router.push('/dashboard');
                    } else if (localStorage.roles.indexOf('OnlineDirector') > -1 || localStorage.roles.indexOf('Supervisor') > -1) {
                        self.$router.push('/dashboard');
                    } else if (localStorage.roles.indexOf('CampusStudent') > -1) {
                        if (localStorage.terms.split(',').length > 3) {
                            self.$router.push('/mentor-dashboard');
                        } else {
                            self.$router.push('/campus-dashboard');
                        }
                    } 

                    else if (localStorage.roles.indexOf('Mentor') > -1) {
                        if (localStorage.terms && localStorage.terms !== '' && localStorage.terms !== 'null') {
                            self.$router.push('/mentor-dashboard');
                        } else {
                            self.$router.push('/mentor-selector');
                        }
                    } else if (localStorage.roles.includes('Faculty')) {
                        self.$router.push('/forum');
                    } else if (localStorage.roles.indexOf('Support') > -1) {
                        self.$router.push('/forum');
                    } 
                    else if (localStorage.roles.includes('CampusInstructor')) {
                        self.$router.push('/campus-dashboard')
                    }
                    else {
                        if (window.location.href.indexOf('redirect_uri') > -1) {
                            self.$router.push('/home?client_id=' + getQueryVariable('client_id') + '&redirect_uri=' + getQueryVariable('redirect_uri'));
                        } else {

                            if (localStorage.terms.split(',').length > 3) {
                                // if the mentor term has not started yet, go to the advanced term dashboard instead
                                let mentorTermHasStarted = false;
                                let mentorTerm = localStorage.terms.split(',');
                                mentorTerm = mentorTerm[mentorTerm.length - 1];
                                mentorTerm = self.terms.find((t) => { return t.id == mentorTerm });
                                const now = new Date();
                                if (now > new Date(mentorTerm.startDate)) mentorTermHasStarted = true;

                                if (mentorTermHasStarted === true) {
                                    self.$router.push('/mentor-dashboard');
                                } else {
                                    self.$router.push('/home');
                                }
                            } else {
                                self.$router.push('/home');
                            }
                        }

                    }
                }
            });

        }
    }
}

</script>
<style lang="scss" scoped>
.image-wrapper {
    position: fixed;
    top: -50px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 550px;
    max-height: 720px;
    z-index: 1;
    width: 640px;
    max-width: 100%;
}

.background {
    position: absolute;
    margin-top: -5vh;
    animation-iteration-count: infinite;
    overflow: hidden;

    &.one {
        animation-name: trippyOne;
        animation-duration: 1s;

    }

    &.two {
        animation-name: trippyTwo;
        animation-duration: 2s;
    }

    &.three {
        animation-name: trippyThree;
        animation-duration: 3s;

    }

    @media screen and (max-width:600px) {
        height: 100vw;
    }
}

section.login {
    max-height: 640px;
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-size: 75vh;
    background-repeat: no-repeat;
    background-position: center center;
    //background-image:url('../assets/img/login-background.png');
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: rgba(0, 0, 0, .5);
    width: 400px;
    max-width: 100%;

    h1 {
        flex: 1 1 auto;
        font-size: 80px;
        text-transform: uppercase;
        font-weight: 300;
        margin-top: -10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        //text-shadow: 3px 3px 15px rgba(0,0,0,1);

    }

    img {
        margin-top: 4rem;
    }

    form {
        margin-bottom: 1vh;

        input {
            height: 35px;
        }

        input[type="text"],
        input[type='password'],
        input[type="email"] {
            background: #000 !important;
            //border-bottom: none!important;
            border: 1px solid rgba(255, 255, 255, .2) !important;
            box-shadow: 0px 0px 20px rgba(0, 0, 0, .5);
        }

        input[type="text"],
        input[type="email"] {
            margin-bottom: 1rem;
        }

        button {
            color: #fff;
            width: 100%;
            background: transparent;
            padding: 0;
            text-transform: uppercase;
            font-weight: 300;
            border: 1px solid #909090;
            border-radius: 0;
            //opacity: .54;
            padding-top: .5rem;
            margin-bottom: 1rem;
            padding-bottom: .5rem;
        }

        ::placeholder {
            text-transform: uppercase;
            text-align: center;
        }

    }
}

a.forgot-password {
    margin-top: 1rem;
    display: inline-block;
}




@keyframes trippyOne {
    from {
        transform: scale3d(1, 1, 1);
        opacity: .2;
    }

    25% {
        transform: scale3d(1.5, 1.5, 1.5);
        opacity: .3333;
    }

    to {
        transform: scale3d(1, 1, 1);
        opacity: .2;
    }

}

@keyframes trippyTwo {
    from {
        transform: scale3d(.1, .1, .1);
        opacity: 1;
    }

    75% {
        transform: scale3d(1.5, 1.5, 1.5);
        opacity: .3333;
    }

    to {
        transform: scale3d(1, 1, 1);
        opacity: .2;
    }
}

@keyframes trippyThree {
    from {
        transform: scale3d(1, 1, 1);
        opacity: .2;
    }

    50% {
        transform: scale3d(1.5, 1.5, 1.5);
        opacity: .333;
    }

    to {
        transform: scale3d(1, 1, 1);
        opacity: .2;
    }

}

.btn {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, .5);
}

</style>
<style lang="scss">
.login-slider {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
}

.login-screen {
    position: fixed;
    top: 0;
    left: 0;
}

.login-slider .artwork {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    transform: scale(1.05);
    animation-fill-mode: forwards;

    &.animated {
        animation: kenburns 11s;
    }
}

@keyframes kenburns {
    0 {
        transform: scale(1.1);
    }

    100% {
        transform: scale(1);
    }
}

.login-slider .art-wrapper {
    height: 100vh;

}

.login-slider .credit {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    text-align: center;
    color: #ccc;
    background: rgba(0, 0, 0, .5);
    padding: 1rem;
    z-index: 99999;
}

</style>



// WEBPACK FOOTER //
// Login.vue?563d2c45